var messager_server = "https://chat.hserm.ru/messager/";
var messager_storage = $('#messager_storage');
var messager_messages = $('#messager_messages');
var messager_chats = $('#messager_chats');
var messager_serach_chat_input = $('#messager_search_input');
var messager_chat_info_bar = $('#messager_bar');
var messager_input = $('#messager_input');
var messager_default_avatar = "/img/no_avatar.png";

var msg_token = "";
var msg_chat_id = 0;
var msg_user_id = 0;
var msg_user_service = 0;
var msg_user_contragenty_id = 0;
var msg_last_message_id = 0;
var msg_first_message_id = 0;

var msg_lock_post = 0;

$('#chat_list_chats').ready(function() {
    if (window.location.pathname == '/messages') {
        msg_token = messager_storage.data('token');
        msg_user_id = messager_storage.data('user-id');
        msg_user_service = 0;
        msg_user_service = messager_storage.data('user-service');
        msg_user_contragenty_id = messager_storage.data('user-contragenty-id');
        console.log('Messager is ready!');
        messager_runner(true);
        setInterval(messager_runner, 5000);
    }
});

function messager_runner(is_first = false) {
    if (msg_lock_post) { return }
    $.post(messager_server + 'runner', {
                token: msg_token,
                chat_id: msg_chat_id,
                user_id: msg_user_id,
                last_message_id: msg_last_message_id,
            },
            function(data) {
                if (is_first && data.chat_id != 0) {
                    msg_chat_id = data.chat_id;
                    msg_first_message_id = data.first_message_id;
                }
                msg_last_message_id = data.last_message_id;
                if (data.chats) {
                    $.each(data.chats, function(key, value) { messager_print_chat(value) });
                    messager_chats.find('li.list-group-item.border-bottom.messager_chat[data-chat-id="' + data.chat_id + '"]').addClass('active');
                }
                if (data.messages) {
                    $.each(data.messages, function(key, value) { messager_print_message(value, 0) });
                    if (is_first) messager_messages[0].scrollIntoView({ block: "end", behavior: "auto" });
                }
                setChatInfo(data.chat_info)
            })
        .fail(function(jqXHR, textStatus, errorThrown) {
            toastr.warning("Потеряно соединение с сервером");
        });
}

function messager_print_chat(value) {
    let unread = (value.count_unread == 0) ? `` : value.count_unread;
    if (messager_chats.find('li.list-group-item.border-bottom.messager_chat[data-chat-id="' + value.chat_id + '"]').length == 0) {
        let loc_chat_id = value.chat_id;
        if (loc_chat_id == 0) {
            loc_chat_id = value.companion_id + '_' + value.companion_service;
        } else {
            messager_chats.find('li.list-group-item.border-bottom.messager_chat[data-chat-id="' + value.companion_id + '_' + value.companion_service + '"]').remove();
        }
        let is_online = (value.type == 0) ? (value.is_online) ? `avatar-online` : `avatar-off` : ``;
        let avatar = (value.avatar) ? ((value.companion_service == 1) ? `/ecimage/` + value.avatar : messager_default_avatar) : messager_default_avatar;
        let is_chat = (value.type == 1) ? `` : `<i></i>`;

        messager_chats.prepend(`
        <li class="list-group-item border-bottom messager_chat" data-chat-id = "` + loc_chat_id + `">
            <div class="media">
                <div class="pr-20">
                    <a class="avatar ` + is_online + `" href="javascript:void(0);">
                        <img class="img-fluid" src="` + avatar + `" alt="` + value.title + `">
                        ` + is_chat + `
                    </a>
                </div>
                <div class="media-body">
                    <h5 class="mt-0 mb-5 p-0 col-12 text-truncate" style = "font-size:12pt">` + value.title + `</h5>
                    <span class="media-time p-0 col-4 text-truncate">` + value.companion_position + `</span>
                </div>
                <div class="pl-20">
                    <span class="badge badge-pill badge-danger">` + unread + `</span>
                </div>
            </div>
        </li>`);
    } else {
        messager_chats.prepend(messager_chats.find('li.list-group-item.border-bottom.messager_chat[data-chat-id="' + value.chat_id + '"]'));
        messager_chats.find('li.list-group-item.border-bottom.messager_chat[data-chat-id="' + value.chat_id + '"] div.media div.pl-20 span.badge').html(unread);
    }
    if (messager_serach_chat_input.val())
        messager_chats.find('li.list-group-item.border-bottom.messager_chat div.media-body h5:not(:contains(' + messager_serach_chat_input.val() + '))').parent().parent().parent().hide();

}

function messager_print_message(value, action = 0) {
    messager_messages.find('div[data-message-id="' + value.id + '"]').remove();

    let sJoinChat = "";
    let sLeaveChat = "";

    if ($('html').attr('lang') == "ru") {
        sJoinChat = "покинул чат";
        sLeaveChat = "присоединился к чату";
    } else {
        sJoinChat = "has joined";
        sLeaveChat = "left the chat";
    }

    let message_content = ``;
    if (value.type == 4) {
        message_content = `<p class='time'>` + value.title + ` ` + sJoinChat + `</p>`;
    } else if (value.type == 3) {
        message_content = `<p class='time'>` + value.title + ` ` + sLeaveChat + `</p>`;
    } else if (value.type == 2) {
        message_content = `<p class='time'>` + value.title + ` ` + `</p>`;
    } else if (value.type == 0 || value.type == 1) {
        let last_message = messager_messages.find('div.chat:last-child');
        let prev_user_id = last_message.data("user-id");
        let prev_user_service = last_message.data("user-service");
        let first_message_id = messager_messages.find('div.chat:first');
        let next_user_id = first_message_id.data("user-id");
        let next_user_service = first_message_id.data("user-service");
        if (prev_user_id == value.user_id && prev_user_service == value.user_service && action == 0) {
            $('div.chat-body[data-message-id="' + last_message.data("message-id") + '"]').append(`
                <div class="chat-content">
                    <!-- <p>` + value.title + ` ` + `</p> -->
                    <p>` + value.body + ` ` + `</p>
                </div>
            `);
        } else if (next_user_id == value.user_id && next_user_service == value.user_service && action == 1) {
            $('div.chat-body[data-message-id="' + first_message_id.data("message-id") + '"]').prepend(`
                <div class="chat-content">
                    <!-- <p>` + value.title + ` ` + `</p> -->
                    <p>` + value.body + ` ` + `</p>
                </div>
            `);
        } else {
            let is_user = (value.place == 1) ? `` : `chat-left`;
            let avatar = (value.avatar) ? ((value.companion_service == 1) ? `/ecimage/` + value.avatar : messager_default_avatar) : messager_default_avatar;
            message_content = `
                <div class="chat ` + is_user + `" data-message-id = "` + value.id + `">
                    <div class="chat-avatar">
                        <a class="avatar" data-toggle="tooltip" href="javascript:void(0);" data-placement="right" title="` + value.title + `">
                            <img src="` + avatar + `" alt="` + value.title + `">
                        </a>
                    </div>
                    <div class="chat-body">
                        <div class="chat-content">
                            <!-- <p>` + value.title + `</p> -->
                            <p>` + value.body + `</p>
                        </div>
                    </div>
                </div>`;
        }
    }
    if (action == 0) {
        messager_messages.append(message_content);
        messager_messages[0].scrollIntoView({ block: "end", behavior: "auto" });
    } else {
        messager_messages.prepend(message_content);
    }
}

function setChatInfo(chat_info) {
    if (chat_info.chat_id) {
        messager_chat_info_bar.show();
        messager_chat_info_bar.find('.chat_title').html(chat_info.title);
        messager_chat_info_bar.find('.chat_position').html(chat_info.companion_position);
        let avatar = (chat_info.avatar) ? ((chat_info.companion_service == 1) ? `/ecimage/` + chat_info.avatar : messager_default_avatar) : messager_default_avatar;
        messager_chat_info_bar.find('.chat_avatar').attr('src', avatar);
        messager_chat_info_bar.find('.chat_avatar').attr('alt', chat_info.title);
    }
}

function send_message() {
    if (messager_input.val()) {
        if (msg_lock_post) { return }
        msg_lock_post = 1;
        $.post(messager_server + 'send', {
            token: msg_token,
            chat_id: msg_chat_id,
            user_id: msg_user_id,
            message: messager_input.val(),
        }, function(data) {
            msg_last_message_id = data.last_message_id;
            messager_input.val('');
            messager_chats.prepend(messager_chats.find('li.list-group-item.border-bottom.messager_chat[data-chat-id="' + data.chat_id + '"]'));
            $.each(data.messages, function(key, value) { messager_print_message(value) });
            messager_messages[0].scrollIntoView({ block: "end", behavior: "auto" });
            messager_chats.find('div.media div.pl-20 span.badge').html('');
            msg_lock_post = 0;
        });
    }
}

$(document).on('click', '.messager_history_messages', function() {
    if (msg_lock_post) { return }
    msg_lock_post = 1;
    $.post(messager_server + 'messages', {
            token: msg_token,
            chat_id: msg_chat_id,
            user_id: msg_user_id,
            first_message_id: msg_first_message_id,
        },
        function(data) {
            if (data.chat_id == msg_chat_id) {
                msg_first_message_id = data.first_message_id;
                $.each(data.messages, function(key, value) { messager_print_message(value, 1) });
            }
            msg_lock_post = 0;
        });
});


$(document).on('click', '.messager_chat_info', function() {
    if (msg_lock_post) { return }
    msg_lock_post = 1;
    $.post(messager_server + 'profile', {
            token: msg_token,
            chat_id: msg_chat_id,
            user_id: msg_user_id,
        },
        function(data) {
            let avatar = (data.avatar) ? data.avatar : messager_default_avatar;
            Swal.fire({
                imageUrl: avatar,
                imageHeight: 150,
                title: data.title,
                text: data.companion_position,
                confirmButtonText: 'Закрыть',
                heightAuto: false,
            });
            msg_lock_post = 0;
        });
});

$(document).on('click', '.messager_chat', function() {
    if ($(this).data('chat-id') != msg_chat_id) {
        if (msg_lock_post) { return }
        msg_lock_post = 1;
        messager_chats.find('li').removeClass('active');
        msg_chat_id = $(this).data('chat-id');
        $(this).addClass('active');
        messager_chats.find('div.media div.pl-20 span.badge').html('');
        messager_messages.empty();
        $.post(messager_server + 'chat', {
            token: msg_token,
            chat_id: msg_chat_id,
            user_id: msg_user_id,
            last_message_id: msg_last_message_id,
        }, function(data) {
            if (data.messages) $.each(data.messages, function(key, value) { messager_print_message(value) });
            msg_first_message_id = data.first_message_id;
            if (msg_chat_id != data.chat_id && msg_chat_id == data.chat_info.companion_id + `_` + data.chat_info.companion_service) {
                msg_last_message_id = data.last_message_id;
                messager_chats.find('li.list-group-item.border-bottom.messager_chat[data-chat-id="' + msg_chat_id + '"]').attr('data-chat-id', data.chat_id);
                msg_chat_id = data.chat_id;
            }
            messager_messages[0].scrollIntoView({ block: "end", behavior: "auto" });
            setChatInfo(data.chat_info);
            msg_lock_post = 0;
        });
    }
});

$(document).on('change', '#messager_search_input', function(e) {
    messager_chats.children().show();
    if (messager_serach_chat_input.val() != '') {
        messager_chats.find('li div.media-body h5').each((index, elem) => {
            elem.parentNode.parentNode.parentNode.style.display = elem.innerText.toLowerCase().indexOf($(this).val().toLowerCase()) != -1 ? '' : 'none';
        });
    }
});

$(document).on('keyup', '#messager_input', function(e) {
    e.preventDefault();
    if (e.which === 13) send_message();
    return false;
});

$(document).on('click', '#messager_button', function(e) {
    e.preventDefault();
    send_message();
    return false;
});
